import * as React from 'react';
import {useFormikContext} from 'formik';
import {CourseObject} from 'api/course';
import Row from 'components/Row';
import Column from 'components/Column';
import SelectPrice, {SelectPriceProps} from 'components/SelectPrice';
import TotalPrice from 'components/TotalPrice';
import CourseBuilderContext from 'components/CourseBuilder/CourseBuilderContext';
import FormContainer from '../../containers/FormContainer';
import {getCurrencyChar} from 'helpers/get-price-label';
import {PriceObject} from 'types';

/**
 * The resale form part of settings
 * @return {React.ReactElement}
 * @constructor
 */
export default function ResaleForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<CourseObject>>();
  const courseContext = React.useContext(CourseBuilderContext);

  /**
   * Render content
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Render discount field
     * @return {JSX.Element}
     */
    function renderDiscount(): JSX.Element {
      /**
       * Handle discount blur
       * @param {React.ChangeEvent<HTMLInputElement>} event
       */
      function handleDiscountBlur(
          event: React.ChangeEvent<HTMLInputElement>,
      ): void {
        formContext.setFieldValue('resale.discount', Number(event.target.value));
        formContext.submitForm();
      }

      const inputProps: SelectPriceProps['inputProps'] = {
        defaultValue: courseContext.course?.resale?.discount,
        onBlur: handleDiscountBlur,
        placeholder: 'Укажите скидку',
      };

      const selectProps: SelectPriceProps['selectProps'] = {
        value: {
          label: courseContext.course?.price?.currency ? (
            getCurrencyChar(courseContext.course?.price?.currency)
          ): '',
          value: courseContext.course?.price?.currency || '',
        },
        disabled: true,
      };

      return (
        <Column>
          <Row>
            <Column>
              <SelectPrice
                label="Скидка"
                inputProps={inputProps}
                selectProps={selectProps}
                required
              />
            </Column>
          </Row>
        </Column>
      );
    }

    /**
     * Render total price
     * @return {JSX.Element}
     */
    function renderTotalPrice(): JSX.Element {
      return (
        <Column>
          <Row>
            <Column>
              {(
                courseContext.course?.price?.amount
                && courseContext.course?.price?.currency
              ) && (
                <TotalPrice
                  sale={formContext.values.resale?.discount}
                  price={courseContext.course?.price as PriceObject}
                />
              )}
            </Column>
          </Row>
        </Column>
      );
    }

    return (
      <Row alignItems="flex-end">
        {renderDiscount()}
        {renderTotalPrice()}
      </Row>
    );
  }
  return (
    <FormContainer
      property="resale"
      label="Повторная продажа"
      collapse
      notAvailableForFree
    >
      {renderContent()}
    </FormContainer>
  );
}
